import { Paper } from '@material-ui/core';
import React from 'react';
import Lang from '../../Lang';
import useStyles from "./styles"

const Leaderboard = () => { 

  const classes = useStyles()

  return (
      <Paper className={classes.records}>
           <h2 lassName={classes.records_title}><Lang props={"Clasificación"} /></h2>
          <p>Próximamente!</p>
      </Paper>
  )
}

export default Leaderboard;
